import type { IOrderAddress, IShippingRequestAddress } from '@rogue/universal'
import { getBuyRequestMeta } from '@/js/helpers/buy-request'
import { checkShippingAddress } from '@/js/helpers/validations/shipping-address'
import type { IRogue } from '@/js/services/RogueTypes'
import type { BuyRequest, BuyRequestMeta } from '@/js/services/types/order'

export type ThreeShipsFreeData = {
  eligibleCount: number,
  hasNotEligible: boolean,
  hasBetterShippingDeal: boolean,
  validShipping: boolean,
}

export const threeShipsFree = (buyRequests: BuyRequest[], shippingAddress: IShippingRequestAddress | IOrderAddress, rogue: IRogue): ThreeShipsFreeData => {
  const qty = {
    total       : 0,
    eligible    : 0,
    notEligible : 0,
    free        : 0,
  }

  let metas: BuyRequestMeta[] = []

  try {
    metas = buyRequests.map(buyRequest => getBuyRequestMeta(buyRequest, rogue))
  } catch (e) {
    rogue.log.info('Error creating buy request metas - not loaded yet?')

    return { eligibleCount: 0, hasBetterShippingDeal: false, hasNotEligible: false, validShipping: false }
  }

  // Count the products that are eligible for shipping deals
  metas.forEach(parentMeta => {
    let productMetas = [parentMeta]

    // Loop through bundled products as well
    if (parentMeta.bundleProducts) {
      productMetas = productMetas.concat(parentMeta.bundleProducts)
    }

    // Add qty for products eligible for different deals
    productMetas.forEach(meta => {
      qty.total += parentMeta.qty
      // Add items that are free
      if (meta.flags.freeShip) qty.free += parentMeta.qty
      // Add items that are 3 ships free or not
      qty[meta.flags.free3 ? 'eligible' : 'notEligible'] += parentMeta.qty
    })
  })

  // Tests for better shipping deals
  // allItemsFree checks if: totalItems = freeItems + threeShipsFreeItems(if there are 3+)
  const allItemsFree = qty.total === qty.free
  const isFreeCart = metas.some(meta => meta.flags.freeCartShip)
  const total = metas.reduce((prev, meta) => prev + meta.total, 0)

  const validShipping = (!shippingAddress || checkShippingAddress(shippingAddress, rogue))
  const hasBetterShippingDeal = total > 5000 || isFreeCart || allItemsFree

  return {
    eligibleCount  : qty.eligible,
    hasNotEligible : qty.notEligible > 0,
    hasBetterShippingDeal,
    validShipping,
  }
}
